import {HasNoteBaseMixin} from "../../widget/mixins/HasNoteBaseMixin.jsx";
import ResourceEditTabBase from "./ResourceEditTabBase.jsx";
import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";
import {DEEP_LINK_URL_KEYS} from "../../../other/constants/OtherKeys.jsx";

export default class ResourceNotesTab extends HasNoteBaseMixin(ResourceEditTabBase) {
  static get $name() {
    return "ResourceNotesTab";
  }

  static get type() {
    return "resourcenotestab";
  }

  get stateId() {
    return PERSISTENCE_STATE_KEYS.resourceEditorNotesGridState;
  }

  get recordType() {
    return "resourceId";
  }

  get deepLinkUrlKey() {
    return DEEP_LINK_URL_KEYS.resource;
  }
}

ResourceNotesTab.initClass();